import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

export const useChangeUserPassword = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Partial<Params>) => {
    return axios.post(
      `${env.verifyServiceUrl}user/change_password/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
